import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

import { fetch_one, fetch_all } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';

import Lenis from "lenis";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";
import { DropzoneArea } from 'mui-file-dropzone';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import QrCodeIcon from '@mui/icons-material/QrCode';

import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  MenuItem,
} from '@mui/material';
import {
  ProfileBox,
  WhiteSection
} from '../../../components/v2/custom';
import {
  DarkGreenButton,
  Dt,
  IconButton,
  LightGreenButton,
  Page,
  Select,
  ShareShower,
  TextButton,
  TextInput,
  TransparentButton,
  Typography
} from '../../../components/v2/styled';
import { Birthdate } from '../../../components/v2/styled/Birthdate';
import { ErrorBox } from '../../../components/v2/styled/ErrorBox';
import { InputButtonVennr } from '../../../components/v2/custom/InputButtonVennr';
import { StockTransferTile } from '../../../components/v2/custom/StockTransferTile';
import { ZichtAccount } from '../../../components/v2/styled/ZichtAccount';

// import { Benefit as Ben } from '../../models/Benefit';
// import { NewsItem as NI } from '../../models/NewsItem';
import { Guardian } from '../../../models/Guardian';
import { StockTransfer } from '../../../models/StockTransfer';
import { User } from '../../../models/User';

var he = require('he');
const { DateTime } = require("luxon");

type Props = {}

export const TransferIndex: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  const [activeKey, setActiveKey] = useState<StockTransfer>();
  const [item, setItem] = useState<File>();
  const [identity, setIdentity] = useState<File>();
  const [identityNew, setIdentityNew] = useState<File>();
  const [identityGuardian, setIdentityGuardian] = useState<File>();
  const [openId, setOpenId] = useState<number>();
  const [newUser, setNewUser] = useState<User>({
    auth_token: '',
    email: '',
    gender: 'M'
  });
  const [guardian, setGuardian] = useState<Guardian>();
  const [pickReceiverState, setPickReceiverState] = useState<number>(0);
  const [maxGiftable, setMaxGiftable] = useState<number>(-1);
  const [receiverInfo, setReceiverInfo] = useState<{
    name?: string; current?: number; id?: number;
  }>({});
  const [editingAddress, setEditingAddress] = useState<boolean>(false);
  const [editingCorAddress, setEditingCorAddress] = useState<boolean>(false);
  const [clickedAtLeastOnce, setClickedAtLeastOnce] = useState<boolean>(false);
  const [isOkay, setIsOkay] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  let count = 0;
  const [samesiesAddress, setSamesiesAddress] = useState<boolean>(true);
  const [samesiesContact, setSamesiesContact] = useState<boolean>(true);
  

  const queryClient = useQueryClient();
  // const {
  //   data: tempUser,
  //   // isLoading: fullBenefitLoading,
  //   // isError: adviceUploadsError,
  //   isSuccess: tempUserSuccess,
  //   // refetch: adviceUploadsRefetch,
  // } = useQuery({
  //   queryKey: ["nw", "user", 'data', login?.id],
  //   queryFn: () =>
  //     fetch_one<User>(
  //       `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
  //       {
  //         object: 'user',
  //         fields: ['id', 'commercial_mail_enabled', 'username', 'first_name', 'last_name', 'birth_date', 'email', 'phone', 'mobile', 'zicht_account', 'street', 'number', 'zip', 'city', 'cor_street', 'cor_number', 'cor_zip', 'cor_city'],
  //         id: login?.id
  //       },
  //       login
  //     ),
  //   enabled: !!login?.id,
  // });
  const {
    data: transfers,
    isLoading: transfersLoading,
    // isError: adviceUploadsError,
    isSuccess: transfersSuccess,
    refetch: transfersRefetch,
  } = useQuery({
    queryKey: ["nw", "user", 'transfers', login?.id],
    queryFn: () =>
      fetch_all<StockTransfer>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
        {
          object: 'stock_transfer',
          fields: [
            'id', 'stock_number', 'created_at', 'status', 'get_blank', 'status_key', 'has_guardian', 'receiver_name'
          ],
          per_page: 9,
          page: page,
          order: 'id DESC',
          filter: {
            advanced: {
              user_id: login?.id
            }
          }
        },
        login
      ),
    enabled: !!login?.id
  });







  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
      update_files?: boolean;
    }) => {
      return fetch_one<{
        custom_result: any
      }>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      if (variables.formData.class_action === "custom_api_check_vennr") {
        setReceiverInfo(data.custom_result);
      }
      if (variables.formData.class_action === "custom_api_create_transfer") {
        // setActiveKey(undefined);
        queryClient.removeQueries({queryKey: ["nw", "user", 'transfers', login?.id]});
        transfersRefetch();
        if (!!data.custom_result.data) setOpenId(data.custom_result.data);
      }
      if (variables.formData.class_action === "custom_api_create_blank") {
        window.open(data.custom_result.downloadable, "_BLANK");
      }
      if (!!variables.update_files) {
        // setActiveKey(undefined);
        queryClient.removeQueries({queryKey: ["nw", "user", 'transfers', login?.id]});
        transfersRefetch();
        if (!!data.custom_result.data) {
          setOpenId(data.custom_result.data);
        }
      }
    },
  });








  const emailCheck = (email:string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const tableRow = (label: string, content: string|undefined, children: any, divider: boolean, copyable?: boolean, lessPadding?: boolean) => {
    return <>
      <Grid item xs={4} sx={{
        paddingTop: !lessPadding ? {
          xs: 1,
          md: 2,
          lg: 3
        } : 0,
        paddingBottom: !lessPadding ? {
          xs: 1,
          md: 2,
          lg: 3
        } : 0,
        paddingLeft: {
          xs: 1,
          md: 2,
          lg: 3
        }
      }}>
        <Typography sx={{
          textTransform: 'uppercase',
          color: theme.palette.primary.light
        }}>{label}</Typography>
      </Grid>
      <Grid item xs={8} sx={{
        paddingTop: !lessPadding ? {
          xs: 1,
          md: 2,
          lg: 3
        } : 0,
        paddingBottom: !lessPadding ? {
          xs: 1,
          md: 2,
          lg: 3
        } : 0,
        paddingRight: {
          xs: 1,
          md: 2,
          lg: 3
        },
        position: 'relative'
      }}>
        {!!content && <Typography variant="body1" html fuck_p_tags>{content}</Typography>}
        {!!children && children}
        {!!copyable && <IconButton
          color="primary"
          sx={{
            position: 'absolute',
            top: {
              xs: !!lessPadding ? -8 : -4,
              md: !!lessPadding ? -8 : 12
            },
            right: 8
          }}
          title={he.decode(t("nw.emission.steps.stock.order_detail.cta_hint.copy").replace(/<[^>]*>?/gm, ''))}
          onClick={(e) => {
            e.preventDefault();
            navigator.clipboard.writeText(he.decode((content || '').replace(/<[^>]*>?/gm, '')));
          }}
        >
          <ContentCopyIcon />
        </IconButton>}
      </Grid>

      {!!divider && <Grid item xs={12}>
        <Divider />
      </Grid>}
    </>;
  }
  
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const lenis = new Lenis({
      // duration: 2,
    });
    lenis.on("scroll", ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
  }, []);
  useEffect(() => {
    if (pickReceiverState === 2) {
      setMaxGiftable(login?.max_giftable || -1);
    } else {
      let can_receive = -1;
      if (!!receiverInfo.id) {
        can_receive = (200 - (receiverInfo.current || 0));
        if ((login?.max_giftable || -1) < can_receive) can_receive = (login?.max_giftable || -1);
      }
      setMaxGiftable(can_receive);
    }
  }, [pickReceiverState, receiverInfo]);
  useEffect(() => {
    // console.log('checking openid');
    if (!!openId && (transfers || []).filter(fff => fff.id === openId).length > 0) {
      // console.log('checking openid, inside if');
      // console.log((transfers || []).filter(fff => fff.id === openId)[0]);
      setActiveKey({
        ...(transfers || []).filter(fff => fff.id === openId)[0],
        status_key: (transfers || []).filter(fff => fff.id === openId)[0].status
      });
      // setOpenId(undefined);
    }
  }, [openId, transfers]);
  // useEffect(() => {
  //   if (!!tempUser) {
  //     setUser({
  //       ...tempUser,
  //       birth_date: DateTime.fromISO(tempUser?.birth_date).toFormat("dd/LL/y")
  //     });
  //     setHasCor(!!tempUser?.cor_street && !!tempUser?.cor_number);
  //   }
  // }, [tempUser]);

  return <Page>
    <WhiteSection isTransparent sx={{
      "& > div > div": {
        padding: 0
      },
      "& > div > div > div > div": {
        minHeight: 20,
        height:'auto'
      }
    }}>
      <Grid container spacing={0} sx={{
        width: {
          xs: '100%',
          lg: '900px'
        },
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 8,
        marginBottom: 8
      }}>
        {!activeKey && <>
          <Grid item xs={12} sx={{
            marginBottom: 2.5
          }}>
            <Typography variant="h2">{t("nw.transfers.my_transfers")}</Typography>
          </Grid>
          <Grid item xs={12} md={6} lg={6} sx={{
            marginBottom: 2.5
          }}>
            <Typography variant="body1">{t("nw.profile.hello").replace(/<[^>]*>?/gm, '')} {login?.is_dutch ? `${login?.voorletters || ''} ${login?.last_name || ''}`.trim() : `${login?.first_name || ''} ${login?.last_name || ''}`.trim()}</Typography>
            <Typography variant="body1">{t("nw.profile.vennoot_number").replace(/<[^>]*>?/gm, '')} {login?.vennoot_number}</Typography>
          </Grid>
          <Grid item xs={12} md={6} lg={6} sx={{
            marginBottom: 2.5,
            textAlign: {
              xs: 'left',
              md: 'right'
            }
          }}>
            {!guardian && <Typography variant="body1">&nbsp;</Typography>}
            {!!guardian && <Typography variant="body1">{t("nw.emission.stocks.subtitle_guardian").replace(/<[^>]*>?/gm, '')} {guardian.first_name} {guardian.last_name}</Typography>}
            <Typography variant="body1">{t("nw.menu.current_saldo").replace(/<[^>]*>?/gm, '')} {login?.stock_number_amount} EUR</Typography>
          </Grid>
          <Grid item xs={12} sx={{
            marginBottom: 2.5
          }}>
            <Typography variant="body1" html fuck_p_tags>{t("nw.transfers.subtitle")}</Typography>
          </Grid>
        </>}

        {!activeKey && <>
          {/* <Grid item xs={12} md={6} lg={6} sx={{
            marginBottom: 2.5,
            paddingLeft: {
              xs: 0,
              md: 1.25
            },
            paddingRight: {
              xs: 0,
              md: 1.25
            }
          }}>
            <StockTransferTile
              isBlank
              shareTypeTag={login?.share_type_tag as 'A' | 'B'}
              onClick={() => {
                // generate and download blank
                mutationCustomAction.mutate({
                  formData: {
                    object: 'stock_transfer',
                    class_action: 'custom_api_create_blank'
                  }
                });
              }}
            />
          </Grid> */}
          <Grid item xs={12} md={6} lg={6} sx={{
            marginBottom: 2.5,
            paddingLeft: {
              xs: 0,
              md: 1.25
            },
            paddingRight: {
              xs: 0,
              md: 1.25
            }
          }}>
            <StockTransferTile
              isNew
              shareTypeTag={login?.share_type_tag as 'A' | 'B'}
              onClick={() => {
                setReceiverInfo({});
                setClickedAtLeastOnce(false);
                setPickReceiverState(0);
                setActiveKey({
                  proposed_amount: 0,
                  status_key: 'open'
                });
                window.scrollTo(0, 0);
              }}
            />
          </Grid>
        </>}
        {!activeKey && (transfers || []).length > 0 && (transfers || []).map(transferKey => <>
          <Grid item xs={12} md={6} lg={6} sx={{
            marginBottom: 2.5,
            paddingLeft: {
              xs: 0,
              md: 1.25
            },
            paddingRight: {
              xs: 0,
              md: 1.25
            }
          }}>
            <StockTransferTile
              transfer={transferKey}
              shareTypeTag={login?.share_type_tag as 'A' | 'B'}
              isApproved={transferKey.status === 'approved'}
              stateColour={{
                wait: 'gold',
                pending: 'gold',
                approved: theme.palette.primary.light,
                disapproved: 'red'
              }[transferKey.status || 'open']}
              onClick={() => {
                setActiveKey({
                  ...transferKey,
                  status_key: transferKey.status
                });
                window.scrollTo(0, 0);
              }}
            />
          </Grid>
        </>)}

        {!!activeKey && <>
          {!activeKey.id && <Grid item xs={12} sx={{
            marginBottom: 2.5
          }}>
            <Typography variant="h2">{t("nw.transfers.new_transfer.title")}</Typography>
          </Grid>}
          {!!activeKey.id && <Grid item xs={12} sx={{
            marginBottom: 2.5
          }}>
            <Typography variant="h2" sx={{textAlign: 'center'}}>{t("nw.transfers.existing_transfer.title", {date: activeKey.created_at, name: activeKey.receiver_name})}</Typography>
          </Grid>}

          {activeKey.status_key !== 'open' && <>
            <Grid item xs={12} sx={{
              marginBottom: 2.5
            }}>
              <Box
                sx={{
                  width: {
                    xs: '100%',
                    md: '100%',
                    lg: '670px'
                  },
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  backgroundColor: 'white'
                }}
              >
                <Grid container spacing={0}>
                  {tableRow(
                    t("nw.transfers.existing_transfer.receiver"), 
                    activeKey.receiver_name, 
                    undefined, 
                    true
                  )}

                  {tableRow(
                    t("nw.transfers.existing_transfer.time_requested"), 
                    undefined, 
                    <Dt d={activeKey.created_at} f="d LLLL y - t"/>, 
                    true
                  )}

                  {tableRow(
                    t("nw.transfers.existing_transfer.amount"), 
                    undefined, 
                    <ShareShower sx={{fontWeight: {xs: 'bold', md: 'normal'}}} amount={activeKey.stock_number} share={login?.share_type_tag as 'A' | 'B'} />, 
                    activeKey.status_key === 'approved'
                  )}

                  {activeKey.status_key === 'approved' && tableRow(
                    t("nw.transfers.existing_transfer.assigned_on"), 
                    activeKey.assigned_on, 
                    undefined, 
                    true
                  )}
                </Grid>
              </Box>
            </Grid>

            {activeKey.status === 'pending' && <Grid item xs={12} sx={{
              marginBottom: 2.5,
              marginTop: 4
            }}>
              <ErrorBox
                type="success"
                text={t("nw.transfers.existing_transfer.pending_explanation")}
              />
            </Grid>}

            {activeKey.status !== 'wait' && <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4, paddingRight: {xs: 0, md: 2.5}}}>
              <TextButton
                id="back_btn"
                label={t("nw.emission.forgot.cta_back")}
                onClick={() => {
                  setActiveKey(undefined);
                  setNewUser({
                    auth_token: '',
                    email: '',
                    gender: 'M'
                  });
                  setGuardian({
                    email: ''
                  });
                  window.scrollTo(0, 0);
                }}
                sx={{
                  marginLeft: 1,
                  marginRight: 1,
                  marginTop: 1
                }}
              />
            </Grid>}
          </>}

          {activeKey.status_key === 'wait' && <>
            {/* Documents */}
            <Grid item xs={12} sx={{
              marginBottom: 2.5,
              marginTop: 4
            }}>
              <Typography variant="h4" html>{t("nw.transfers.new_transfer.download_document")}</Typography>
              <Typography variant="subtitle1" html>{t("nw.transfers.new_transfer.download_document_explanation")}</Typography>
              {!!activeKey.get_blank && <DarkGreenButton
                id="download_document"
                label={t("nw.transfers.new_transfer.download_document_btn")}
                onClick={() => {
                  window.open(activeKey.get_blank, "_BLANK");
                }}
                sx={{
                  // marginLeft: 1,
                  // marginRight: 1,
                  marginTop: 1
                }}    
              />}
              {!activeKey.get_blank && <ErrorBox
                type="error"
                text={t("nw.transfers.new_transfer.blank_doc_error")}
              />}
            </Grid>

            <Grid item xs={12} sx={{
              marginBottom: 2.5,
              marginTop: 4
            }}>
              <Typography variant="h4" html>{t("nw.transfers.new_transfer.sender_info")}</Typography>
            </Grid>
            <Grid item xs={12} sx={{
              display: {
                xs: 'none', md: 'flex'
              },
              "& .cust_dropzonearea > div > div": {
                flexBasis: 'auto !important',
                marginLeft: 'auto',
                marginRight: 'auto'
              }
            }}>
              <DropzoneArea
                acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                filesLimit={1}
                fileObjects={[]}
                dropzoneText={he.decode(t('nw.general.dropzone_text').replace(/<[^>]*>?/gm, ''))}
                getDropRejectMessage={(rejectedFile, x, y) => {
                  return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                }}
                onChange={(files) => {
                  // this.setState({user: {...this.state.user, identity: files[0]}});
                  setIdentity(files[0]);
                }}
                maxFileSize={5000000}
                previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                dropzoneClass="cust_dropzonearea"
              />
            </Grid>
            <Grid item xs={12} sx={{
              display: {
                xs: 'flex', md: 'none'
              },
              "& .cust_dropzonearea > div > div": {
                flexBasis: 'auto !important',
                marginLeft: 'auto',
                marginRight: 'auto'
              }
            }}>
              <DropzoneArea
                acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                filesLimit={1}
                fileObjects={[]}
                dropzoneText={he.decode(t('nw.general.dropzone_text_mobile').replace(/<[^>]*>?/gm, ''))}
                getDropRejectMessage={(rejectedFile, x, y) => {
                  return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                }}
                onChange={(files) => {
                  // this.setState({user: {...this.state.user, identity: files[0]}});
                  setIdentity(files[0]);
                }}
                maxFileSize={5000000}
                previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                dropzoneClass="cust_dropzonearea"
              />
            </Grid>
            <Grid item xs={12} sx={{
              marginBottom: 2.5,
              marginTop: 4
            }}>
              <Typography variant="h4" html>{t("nw.transfers.new_transfer.identity_receiver")}</Typography>
            </Grid>
            {!activeKey.has_guardian && <>
              <Grid item xs={12} sx={{
                display: {
                  xs: 'none', md: 'flex'
                },
                "& .cust_dropzonearea > div > div": {
                  flexBasis: 'auto !important',
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }
              }}>
                <DropzoneArea
                  acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                  filesLimit={1}
                  fileObjects={[]}
                  dropzoneText={he.decode(t('nw.general.dropzone_text').replace(/<[^>]*>?/gm, ''))}
                  getDropRejectMessage={(rejectedFile, x, y) => {
                    return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                  }}
                  onChange={(files) => {
                    // this.setState({user: {...this.state.user, identity: files[0]}});
                  setIdentityNew(files[0]);
                  }}
                  maxFileSize={5000000}
                  previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                  dropzoneClass="cust_dropzonearea"
                />
              </Grid>
              <Grid item xs={12} sx={{
                display: {
                  xs: 'flex', md: 'none'
                },
                "& .cust_dropzonearea > div > div": {
                  flexBasis: 'auto !important',
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }
              }}>
                <DropzoneArea
                  acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                  filesLimit={1}
                  fileObjects={[]}
                  dropzoneText={he.decode(t('nw.general.dropzone_text_mobile').replace(/<[^>]*>?/gm, ''))}
                  getDropRejectMessage={(rejectedFile, x, y) => {
                    return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                  }}
                  onChange={(files) => {
                    // this.setState({user: {...this.state.user, identity: files[0]}});
                  setIdentityNew(files[0]);
                  }}
                  maxFileSize={5000000}
                  previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                  dropzoneClass="cust_dropzonearea"
                />
              </Grid>
            </>}
            {!!activeKey.has_guardian && <>
              <Grid item xs={12} md={6} container spacing={2} sx={{alignContent: 'baseline'}}>
                <Grid item xs={12} sx={{textAlign: 'center'}}>
                  <Typography variant="subtitle1" html fuck_p_tags sx={{
                    display: 'inline-block',
                  }}>{t("nw.transfers.new_transfer.identity_minor")}</Typography>
                </Grid>
                <Grid item xs={12} sx={{
                  display: {
                    xs: 'none', md: 'flex'
                  },
                  "& .cust_dropzonearea > div > div": {
                    flexBasis: 'auto !important',
                    marginLeft: 'auto',
                    marginRight: 'auto'
                  }
                }}>
                  <DropzoneArea
                    acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                    filesLimit={1}
                    fileObjects={[]}
                    dropzoneText={he.decode(t('nw.general.dropzone_text').replace(/<[^>]*>?/gm, ''))}
                    getDropRejectMessage={(rejectedFile, x, y) => {
                      return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                    }}
                    onChange={(files) => {
                      // this.setState({user: {...this.state.user, identity: files[0]}});
                      setIdentityNew(files[0]);
                    }}
                    maxFileSize={5000000}
                    previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                    dropzoneClass="cust_dropzonearea"
                  />
                </Grid>
                <Grid item xs={12} sx={{
                  display: {
                    xs: 'flex', md: 'none'
                  },
                  "& .cust_dropzonearea > div > div": {
                    flexBasis: 'auto !important',
                    marginLeft: 'auto',
                    marginRight: 'auto'
                  }
                }}>
                  <DropzoneArea
                    acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                    filesLimit={1}
                    fileObjects={[]}
                    dropzoneText={he.decode(t('nw.general.dropzone_text_mobile').replace(/<[^>]*>?/gm, ''))}
                    getDropRejectMessage={(rejectedFile, x, y) => {
                      return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                    }}
                    onChange={(files) => {
                      // this.setState({user: {...this.state.user, identity: files[0]}});
                      setIdentityNew(files[0]);
                    }}
                    maxFileSize={5000000}
                    previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                    dropzoneClass="cust_dropzonearea"
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} container spacing={2} sx={{alignContent: 'baseline'}}>
                <Grid item xs={12} sx={{textAlign: 'center'}}>
                  <Typography variant="subtitle1" html fuck_p_tags sx={{
                    display: 'inline-block',
                  }}>{t("nw.transfers.new_transfer.identity_guardian")}</Typography>
                </Grid>
                <Grid item xs={12} sx={{
                  display: {
                    xs: 'none', md: 'flex'
                  },
                  "& .cust_dropzonearea > div > div": {
                    flexBasis: 'auto !important',
                    marginLeft: 'auto',
                    marginRight: 'auto'
                  }
                }}>
                  <DropzoneArea
                    acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                    filesLimit={1}
                    fileObjects={[]}
                    dropzoneText={he.decode(t('nw.general.dropzone_text').replace(/<[^>]*>?/gm, ''))}
                    getDropRejectMessage={(rejectedFile, x, y) => {
                      return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                    }}
                    onChange={(files) => {
                      // this.setState({user: {...this.state.user, identity: files[0]}});
                      setIdentityGuardian(files[0]);
                    }}
                    maxFileSize={5000000}
                    previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                    dropzoneClass="cust_dropzonearea"
                  />
                </Grid>
                <Grid item xs={12} sx={{
                  display: {
                    xs: 'flex', md: 'none'
                  },
                  "& .cust_dropzonearea > div > div": {
                    flexBasis: 'auto !important',
                    marginLeft: 'auto',
                    marginRight: 'auto'
                  }
                }}>
                  <DropzoneArea
                    acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                    filesLimit={1}
                    fileObjects={[]}
                    dropzoneText={he.decode(t('nw.general.dropzone_text_mobile').replace(/<[^>]*>?/gm, ''))}
                    getDropRejectMessage={(rejectedFile, x, y) => {
                      return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                    }}
                    onChange={(files) => {
                      // this.setState({user: {...this.state.user, identity: files[0]}});
                      setIdentityGuardian(files[0]);
                    }}
                    maxFileSize={5000000}
                    previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                    dropzoneClass="cust_dropzonearea"
                  />
                </Grid>
              </Grid>
            </>}
            <Grid item xs={12} sx={{
              marginBottom: 2.5,
              marginTop: 4
            }}>
              <Typography variant="h4" html>{t("nw.transfers.new_transfer.signed_document")}</Typography>
            </Grid>
            <Grid item xs={12} sx={{
              display: {
                xs: 'none', md: 'flex'
              },
              "& .cust_dropzonearea > div > div": {
                flexBasis: 'auto !important',
                marginLeft: 'auto',
                marginRight: 'auto'
              }
            }}>
              <DropzoneArea
                acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                filesLimit={1}
                fileObjects={[]}
                dropzoneText={he.decode(t('nw.general.dropzone_text').replace(/<[^>]*>?/gm, ''))}
                getDropRejectMessage={(rejectedFile, x, y) => {
                  return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                }}
                onChange={(files) => {
                  // this.setState({user: {...this.state.user, identity: files[0]}});
                  setItem(files[0]);
                }}
                maxFileSize={5000000}
                previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                dropzoneClass="cust_dropzonearea"
              />
            </Grid>
            <Grid item xs={12} sx={{
              display: {
                xs: 'flex', md: 'none'
              },
              "& .cust_dropzonearea > div > div": {
                flexBasis: 'auto !important',
                marginLeft: 'auto',
                marginRight: 'auto'
              }
            }}>
              <DropzoneArea
                acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                filesLimit={1}
                fileObjects={[]}
                dropzoneText={he.decode(t('nw.general.dropzone_text_mobile').replace(/<[^>]*>?/gm, ''))}
                getDropRejectMessage={(rejectedFile, x, y) => {
                  return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                }}
                onChange={(files) => {
                  // this.setState({user: {...this.state.user, identity: files[0]}});
                  setItem(files[0]);
                }}
                maxFileSize={5000000}
                previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                dropzoneClass="cust_dropzonearea"
              />
            </Grid>

            <Grid item xs={12} sx={{textAlign: 'left'}}>
              <Typography variant="h4" sx={{
                marginTop: 4,
                display: 'inline-block'
              }}>{t("nw.emission.choice_me_new_itsme.title_overview")}</Typography>
            </Grid>
            <Grid item xs={12} sx={{textAlign: 'left'}}>
              {!!identity && <CheckCircleOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.primary.light}} />}
              {!identity && <ErrorOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.warning.main}} />}
              <Typography variant="subtitle1" sx={{
                marginTop: 1,
                display: 'inline-block',
                color: !identity ? theme.palette.warning.main : theme.palette.primary.light,
              }}>{t("nw.transfers.new_transfer.sender_info")}</Typography>
            </Grid>
            <Grid item xs={12} sx={{textAlign: 'left'}}>
              {!(!identityNew || (!!activeKey.has_guardian && !identityGuardian)) && <CheckCircleOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.primary.light}} />}
              {(!identityNew || (!!activeKey.has_guardian && !identityGuardian)) && <ErrorOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.warning.main}} />}
              <Typography variant="subtitle1" sx={{
                marginTop: 1,
                display: 'inline-block',
                color: (!identityNew || (!!activeKey.has_guardian && !identityGuardian)) ? theme.palette.warning.main : theme.palette.primary.light,
              }}>{t("nw.transfers.new_transfer.identity_receiver")}</Typography>
            </Grid>
            <Grid item xs={12} sx={{textAlign: 'left'}}>
              {!!item && <CheckCircleOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.primary.light}} />}
              {!item && <ErrorOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.warning.main}} />}
              <Typography variant="subtitle1" sx={{
                marginTop: 1,
                display: 'inline-block',
                color: !item ? theme.palette.warning.main : theme.palette.primary.light,
              }}>{t("nw.transfers.new_transfer.signed_document")}</Typography>
            </Grid>

            <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4, paddingRight: {xs: 0, md: 2.5}}}>
              <TextButton
                id="back_btn"
                label={t("nw.emission.forgot.cta_back")}
                onClick={() => {
                  setActiveKey(undefined);
                  window.scrollTo(0, 0);
                }}
                sx={{
                  marginLeft: 1,
                  marginRight: 1,
                  marginTop: 1
                }}
              />
              <DarkGreenButton
                id="next_btn"
                loading={!!mutationCustomAction.isPending || transfersLoading}
                label={t("nw.emission.choice_me_new_itsme.cta_next")}
                disabled={
                  !!mutationCustomAction.isPending || !item || !identity || !identityNew || (!!activeKey.has_guardian && !identityGuardian)
                }
                onClick={() => {
                  if (!mutationCustomAction.isPending) {
                    // onSubmit();
                    setOpenId(undefined);
                    const ob:any = {
                      object: 'stock_transfer',
                      class_action: 'custom_api_update_files',
                      id: activeKey.id,
                      identity: identity,
                      item: item,
                      identity_new: identityNew
                    };
                    if (!!activeKey.has_guardian) ob.identity_guardian = identityGuardian;

                    const formData = new FormData();
                    Object.keys(ob).forEach(key => {
                      // @ts-ignore
                      if (!!ob[key]) formData.append(key, ob[key]);
                    });

                    mutationCustomAction.mutate({
                      formData: formData,
                      update_files: true
                    })
                  }
                }}
                sx={{
                  marginLeft: 1,
                  marginRight: 1,
                  marginTop: 1,
                  color: 'white !important'
                }}
              />
            </Grid>
          </>}

          {activeKey.status_key === 'open' && <>
            <Grid item xs={12} sx={{
              marginBottom: 2.5
            }}>
              {login?.share_type_tag !== 'A' && <Typography variant="body1" html sx={{
                marginTop: -1
              }}>{t("nw.transfers.new_transfer_detail")}</Typography>}
              {login?.share_type_tag === 'A' && <Typography variant="body1" html sx={{
                marginTop: -1
              }}>{t("nw.transfers.new_transfer_detail_for_a")}</Typography>}
            </Grid>

            {login?.share_type_tag !== 'A' && <>
              {/* Choose receiver */}
              {/* <Grid item xs={12} sx={{
                marginBottom: 2.5,
                marginTop: 4
              }}>
                <Typography variant="h4" html>{t("nw.transfers.new_transfer.sender_info")}</Typography>
              </Grid>
              <Grid item xs={12} sx={{
                display: {
                  xs: 'none', md: 'flex'
                },
                "& .cust_dropzonearea > div > div": {
                  flexBasis: 'auto !important',
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }
              }}>
                <DropzoneArea
                  acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                  filesLimit={1}
                  fileObjects={[]}
                  dropzoneText={he.decode(t('nw.general.dropzone_text').replace(/<[^>]*>?/gm, ''))}
                  onChange={(files) => {
                    // this.setState({user: {...this.state.user, identity: files[0]}});
                    setItem(files[0]);
                  }}
                  maxFileSize={5000000}
                  previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                  dropzoneClass="cust_dropzonearea"
                />
              </Grid>
              <Grid item xs={12} sx={{
                display: {
                  xs: 'flex', md: 'none'
                },
                "& .cust_dropzonearea > div > div": {
                  flexBasis: 'auto !important',
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }
              }}>
                <DropzoneArea
                  acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                  filesLimit={1}
                  fileObjects={[]}
                  dropzoneText={he.decode(t('nw.general.dropzone_text_mobile').replace(/<[^>]*>?/gm, ''))}
                  onChange={(files) => {
                    // this.setState({user: {...this.state.user, identity: files[0]}});
                    setItem(files[0]);
                  }}
                  maxFileSize={5000000}
                  previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                  dropzoneClass="cust_dropzonearea"
                />
              </Grid> */}
              <Grid item xs={12} sx={{
                marginBottom: 2.5,
                // marginTop: 6.5
              }}>
                <Typography variant="h4" html>{t("nw.transfers.new_transfer.receiver_info")}</Typography>
              </Grid>
              <Grid item xs={12} sx={{textAlign: 'center', marginBottom: 2.5}}>
                <DarkGreenButton
                  id="existing_member"
                  label={t("nw.transfers.new_transfer_choice.existing_member")}
                  onClick={() => {
                    setPickReceiverState(1);
                  }}
                  sx={{
                    marginLeft: 1,
                    marginRight: 1,
                    marginTop: 1
                  }}
                />
                <LightGreenButton
                  id="new_member"
                  label={t("nw.transfers.new_transfer_choice.new_member")}
                  onClick={() => {
                    setPickReceiverState(2);
                    setReceiverInfo({});
                  }}
                  sx={{
                    marginLeft: 1,
                    marginRight: 1,
                    marginTop: 1
                  }}
                />
              </Grid>

              {pickReceiverState === 1 && <>
                {/* Existing member */}
                <Grid item xs={12} sx={{textAlign: 'left', marginBottom: 2.5}}>
                  <Typography variant="caption">{t("nw.transfers.new_transfer.vennoot_number")}</Typography><br/>
                  <InputButtonVennr
                    value={activeKey.vennoot_number || ''}
                    setValue={(s) => {
                      setActiveKey({
                        ...activeKey,
                        vennoot_number: s
                      });
                    }}
                    btnLabel={t("nw.transfers.new_transfer.find_vennoot_cta")}
                    onClick={() => {
                      setClickedAtLeastOnce(true);
                      // custom_api_check_vennr
                      mutationCustomAction.mutate({
                        formData: {
                          object: 'user',
                          class_action: 'custom_api_check_vennr',
                          vennoot_number: activeKey.vennoot_number
                        }
                      });
                    }}
                    sx={{
                      marginTop: 0
                    }}
                  />
                </Grid>
                <Grid item xs={12} sx={{textAlign: 'left', marginBottom: 2.5}}>
                  {clickedAtLeastOnce && !receiverInfo?.id && <ErrorBox
                    type="error"
                    text={t("nw.transfers.new_transfer.amount_error")}
                  />}
                  {clickedAtLeastOnce && !!receiverInfo?.id && <Box sx={{
                    maxWidth: {
                      xs: '100%',
                      lg: '440px'
                    },
                    padding: 2.5,
                    borderRadius: '6px',
                    backgroundColor: theme.palette.secondary.light,
                  }}>
                    <Typography variant="subtitle1" sx={{
                      textDecoration: 'underline'
                    }}>{t("nw.transfers.new_transfer.vennoot_info")}</Typography>
                    <Typography variant="caption">{t("nw.transfers.new_transfer.vennoot_info_name")}</Typography>
                    <Typography variant="body1" sx={{paddingLeft: 2}}>{receiverInfo.name || '-'}</Typography>
                    <Typography variant="caption">{t("nw.transfers.new_transfer.vennoot_info_can_receive")}</Typography>
                    <Typography variant="body1" sx={{paddingLeft: 2}}>{!!receiverInfo.id ? (200 - (receiverInfo.current || 0)) : '-'}</Typography>
                    {false && !!receiverInfo.id && (receiverInfo.current || 0) < 200 && <DarkGreenButton
                      label={t("nw.transfers.new_transfer.vennoot_info_confirm")}
                      id="confirmbtn"
                      disabled={!receiverInfo.id}
                      onClick={() => {
                        // Bevestigen en amount tonen
                      }}
                      sx={{
                        marginTop: 2
                      }}
                    />}
                  </Box>}
                </Grid>
              </>}
              {pickReceiverState === 2 && <>
                {/* New member */}
                <Grid container spacing={2} sx={{marginBottom: 4}}>
                  <Grid item xs={12} sx={{textAlign: 'left'}}>
                    <Typography variant="h4" sx={{
                      marginTop: 4,
                      display: 'inline-block'
                    }}>{t("nw.emission.choice_me_new_itsme.title_personal")}</Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <TextInput
                      value={newUser?.first_name || ''}
                      onChange={(v) => {
                        setNewUser({
                          ...(newUser || {
                            auth_token: '',
                            email: ''
                          }),
                          first_name: v.toString()
                        });
                      }}
                      starred
                      caption={t("nw.user_info.first_name")}
                      sx={{
                        borderRadius: "8px",
                        width: '100%',
                        border: "2px solid transparent",
                        borderColor: theme.palette.primary.dark,
                        paddingTop: 0.25,
                        paddingBottom: 0.25,
                        height: '40px',
                        backgroundColor: 'transparent',
                      }}
                    />
                  </Grid>
                  <Grid item xs={7}>
                    <TextInput
                      value={newUser?.last_name || ''}
                      onChange={(v) => {
                        setNewUser({
                          ...(newUser || {
                            auth_token: '',
                            email: ''
                          }),
                          last_name: v.toString()
                        });
                      }}
                      starred
                      caption={t("nw.user_info.last_name")}
                      sx={{
                        borderRadius: "8px",
                        width: '100%',
                        border: "2px solid transparent",
                        borderColor: theme.palette.primary.dark,
                        paddingTop: 0.25,
                        paddingBottom: 0.25,
                        height: '40px',
                        backgroundColor: 'transparent',
                      }}
                    />
                  </Grid>
                  <Grid item xs={7}>
                    <Birthdate
                      value={newUser?.birth_date || ''}
                      onChange={(v) => {
                        setNewUser({
                          ...(newUser || {
                            auth_token: '',
                            email: ''
                          }),
                          birth_date: v.target.value
                        });
                      }}
                      starred
                      caption={t("nw.user_info.birth_date")}
                      // placeholder={t("nw.contact.form.placeholder.first_name")}
                      sx={{
                        borderRadius: "8px",
                        width: '100%',
                        border: "2px solid transparent",
                        borderColor: theme.palette.primary.dark,
                        paddingTop: 0.25,
                        paddingBottom: 0.25,
                        height: '40px',
                        backgroundColor: 'transparent',
                      }}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <Select
                      id="subjects"
                      caption={t("nw.user_info.gender")}
                      fullWidth
                      value={newUser?.gender || "M"}
                      setValue={(v) => {
                        setNewUser({
                          ...(newUser || {
                            auth_token: '',
                            email: ''
                          }),
                          gender: v.toString()
                        });
                      }}
                      sx={{
                        borderRadius: "8px",
                        width: '100%',
                        border: "2px solid transparent",
                        borderColor: theme.palette.primary.dark,
                        height: '40px',
                        paddingTop: 0.25,
                        paddingBottom: 0.25,
                        backgroundColor: 'transparent',
                        "&:hover fieldset": {
                          borderColor: 'transparent !important'
                        }
                      }}
                    >
                      <MenuItem value="M">{he.decode((t("nw.user_info.genders.male")).replace(/<[^>]*>?/gm, ''))}</MenuItem>
                      <MenuItem value="V">{he.decode((t("nw.user_info.genders.female")).replace(/<[^>]*>?/gm, ''))}</MenuItem>
                    </Select>
                  </Grid>
                  {!!newUser?.birth_date && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y").isValid && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18}) && <>
                    {/* Voogd stuff */}
                    <Grid item xs={12} sx={{textAlign: 'left'}}>
                      <Typography variant="h4" sx={{
                        marginTop: 4,
                        display: 'inline-block'
                      }}>{t("nw.emission.choice_me_new_itsme.title_personal_guardian")}</Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <TextInput
                        value={guardian?.first_name || ''}
                        onChange={(v) => {
                          setGuardian({
                            ...(guardian || {
                              auth_token: '',
                              email: ''
                            }),
                            first_name: v.toString()
                          });
                        }}
                        starred
                        caption={t("nw.user_info.first_name")}
                        sx={{
                          borderRadius: "8px",
                          width: '100%',
                          border: "2px solid transparent",
                          borderColor: theme.palette.primary.dark,
                          paddingTop: 0.25,
                          paddingBottom: 0.25,
                          height: '40px',
                          backgroundColor: 'transparent',
                        }}
                      />
                    </Grid>
                    <Grid item xs={7}>
                      <TextInput
                        value={guardian?.last_name || ''}
                        onChange={(v) => {
                          setGuardian({
                            ...(guardian || {
                              auth_token: '',
                              email: ''
                            }),
                            last_name: v.toString()
                          });
                        }}
                        starred
                        caption={t("nw.user_info.last_name")}
                        sx={{
                          borderRadius: "8px",
                          width: '100%',
                          border: "2px solid transparent",
                          borderColor: theme.palette.primary.dark,
                          paddingTop: 0.25,
                          paddingBottom: 0.25,
                          height: '40px',
                          backgroundColor: 'transparent',
                        }}
                      />
                    </Grid>
                    <Grid item xs={7}>
                      <Birthdate
                        value={guardian?.birth_date || ''}
                        onChange={(v) => {
                          setGuardian({
                            ...(guardian || {
                              auth_token: '',
                              email: ''
                            }),
                            birth_date: v.target.value
                          });
                        }}
                        starred
                        caption={t("nw.user_info.birth_date")}
                        // placeholder={t("nw.contact.form.placeholder.first_name")}
                        sx={{
                          borderRadius: "8px",
                          width: '100%',
                          border: "2px solid transparent",
                          borderColor: theme.palette.primary.dark,
                          paddingTop: 0.25,
                          paddingBottom: 0.25,
                          height: '40px',
                          backgroundColor: 'transparent',
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{textAlign: 'left'}}>
                      <Typography variant="h4" sx={{
                        marginTop: 4,
                        display: 'inline-block'
                      }}>{t("nw.emission.choice_me_new_itsme.title_contact_extra")}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6} container spacing={2}>
                      <Grid item xs={12} sx={{textAlign: 'center'}}>
                        <Typography variant="subtitle1" sx={{
                          display: 'inline-block',
                        }}>{t("nw.emission.choice_me_new_itsme.title_personal_ven")}</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <TextInput
                          value={newUser?.email || ''}
                          type="email"
                          onChange={(v) => {
                            setNewUser({
                              ...(newUser || {
                                auth_token: '',
                                email: ''
                              }),
                              email: v
                            });
                            if (samesiesContact) setGuardian({
                              ...(guardian || {
                                auth_token: '',
                                email: ''
                              }),
                              email: v
                            });
                          }}
                          starred
                          caption={t("nw.user_info.email")}
                          sx={{
                            borderRadius: "8px",
                            width: '100%',
                            border: "2px solid transparent",
                            borderColor: theme.palette.primary.dark,
                            paddingTop: 0.25,
                            paddingBottom: 0.25,
                            height: '40px',
                            backgroundColor: 'transparent',
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextInput
                          value={newUser?.phone || ''}
                          onChange={(v) => {
                            setNewUser({
                              ...(newUser || {
                                auth_token: '',
                                email: ''
                              }),
                              phone: v.toString()
                            });
                            if (samesiesContact) setGuardian({
                              ...(guardian || {
                                auth_token: '',
                                email: ''
                              }),
                              phone: v.toString()
                            });
                          }}
                          starred
                          caption={t("nw.user_info.phone")}
                          sx={{
                            borderRadius: "8px",
                            width: '100%',
                            border: "2px solid transparent",
                            borderColor: theme.palette.primary.dark,
                            paddingTop: 0.25,
                            paddingBottom: 0.25,
                            height: '40px',
                            backgroundColor: 'transparent',
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={6} container spacing={2} sx={{alignContent: 'baseline'}}>
                      <Grid item xs={12} sx={{textAlign: 'center'}}>
                        <Typography variant="subtitle1" sx={{
                          display: 'inline-block',
                        }}>{t("nw.emission.choice_me_new_itsme.title_personal_guardian")}</Typography>
                      </Grid>
                      {!!samesiesContact && <Grid item xs={12}>
                        <TransparentButton
                          label={t("nw.emission.choice_minor.contact_details_diff")}
                          id='contact_details_diff'
                          onClick={() => {
                            setSamesiesContact(false);
                          }}
                          sx={{
                            marginTop: 3
                          }}
                        />
                      </Grid>}
                      {!samesiesContact && <>
                        <Grid item xs={12}>
                          <TextInput
                            value={guardian?.email || ''}
                            type="email"
                            onChange={(v) => {
                              setGuardian({
                                ...(guardian || {
                                  auth_token: '',
                                  email: ''
                                }),
                                email: v
                              });
                            }}
                            starred
                            caption={t("nw.user_info.email")}
                            sx={{
                              borderRadius: "8px",
                              width: '100%',
                              border: "2px solid transparent",
                              borderColor: theme.palette.primary.dark,
                              paddingTop: 0.25,
                              paddingBottom: 0.25,
                              height: '40px',
                              backgroundColor: 'transparent',
                            }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextInput
                            value={guardian?.phone || ''}
                            onChange={(v) => {
                              setGuardian({
                                ...(guardian || {
                                  auth_token: '',
                                  email: ''
                                }),
                                phone: v.toString()
                              });
                            }}
                            starred
                            caption={t("nw.user_info.phone")}
                            sx={{
                              borderRadius: "8px",
                              width: '100%',
                              border: "2px solid transparent",
                              borderColor: theme.palette.primary.dark,
                              paddingTop: 0.25,
                              paddingBottom: 0.25,
                              height: '40px',
                              backgroundColor: 'transparent',
                            }}
                          />
                        </Grid>
                      </>}
                    </Grid>
                    <Grid item xs={12} sx={{textAlign: 'left'}}>
                      <Typography variant="h4" sx={{
                        marginTop: 4,
                        display: 'inline-block'
                      }}>{t("nw.emission.choice_me_new_itsme.title_address")}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6} container spacing={2} sx={{alignContent: 'baseline'}}>
                      <Grid item xs={12} sx={{textAlign: 'center'}}>
                        <Typography variant="subtitle1" sx={{
                          display: 'inline-block',
                        }}>{t("nw.emission.choice_me_new_itsme.title_personal_ven")}</Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <TextInput
                          value={newUser?.street || ''}
                          onChange={(v) => {
                            setNewUser({
                              ...(newUser || {
                                auth_token: '',
                                email: ''
                              }),
                              street: v
                            });
                            if (samesiesAddress) setGuardian({
                              ...(guardian || {
                                auth_token: '',
                                email: ''
                              }),
                              street: v
                            });
                          }}
                          starred
                          caption={t("nw.user_info.street")}
                          sx={{
                            borderRadius: "8px",
                            width: '100%',
                            border: "2px solid transparent",
                            borderColor: theme.palette.primary.dark,
                            paddingTop: 0.25,
                            paddingBottom: 0.25,
                            height: '40px',
                            backgroundColor: 'transparent',
                          }}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <TextInput
                          value={newUser?.number || ''}
                          onChange={(v) => {
                            setNewUser({
                              ...(newUser || {
                                auth_token: '',
                                email: ''
                              }),
                              number: v
                            });
                            if (samesiesAddress) setGuardian({
                              ...(guardian || {
                                auth_token: '',
                                email: ''
                              }),
                              number: v
                            });
                          }}
                          starred
                          caption={t("nw.user_info.number")}
                          sx={{
                            borderRadius: "8px",
                            width: '100%',
                            border: "2px solid transparent",
                            borderColor: theme.palette.primary.dark,
                            paddingTop: 0.25,
                            paddingBottom: 0.25,
                            height: '40px',
                            backgroundColor: 'transparent',
                          }}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <TextInput
                          value={newUser?.zip || ''}
                          onChange={(v) => {
                            setNewUser({
                              ...(newUser || {
                                auth_token: '',
                                email: ''
                              }),
                              zip: v
                            });
                            if (samesiesAddress) setGuardian({
                              ...(guardian || {
                                auth_token: '',
                                email: ''
                              }),
                              zip: v
                            });
                          }}
                          starred
                          caption={t("nw.user_info.zip")}
                          sx={{
                            borderRadius: "8px",
                            width: '100%',
                            border: "2px solid transparent",
                            borderColor: theme.palette.primary.dark,
                            paddingTop: 0.25,
                            paddingBottom: 0.25,
                            height: '40px',
                            backgroundColor: 'transparent',
                          }}
                        />
                      </Grid>
                      <Grid item xs={8}>
                        <TextInput
                          value={newUser?.city || ''}
                          onChange={(v) => {
                            setNewUser({
                              ...(newUser || {
                                auth_token: '',
                                email: ''
                              }),
                              city: v
                            });
                            if (samesiesAddress) setGuardian({
                              ...(guardian || {
                                auth_token: '',
                                email: ''
                              }),
                              city: v
                            });
                          }}
                          starred
                          caption={t("nw.user_info.city")}
                          sx={{
                            borderRadius: "8px",
                            width: '100%',
                            border: "2px solid transparent",
                            borderColor: theme.palette.primary.dark,
                            paddingTop: 0.25,
                            paddingBottom: 0.25,
                            height: '40px',
                            backgroundColor: 'transparent',
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={6} container spacing={2} sx={{alignContent: 'baseline'}}>
                      <Grid item xs={12} sx={{textAlign: 'center'}}>
                        <Typography variant="subtitle1" sx={{
                          display: 'inline-block',
                        }}>{t("nw.emission.choice_me_new_itsme.title_personal_guardian")}</Typography>
                      </Grid>
                      {!!samesiesAddress && <Grid item xs={12}>
                        <TransparentButton
                          label={t("nw.emission.choice_minor.address_details_diff")}
                          id='address_details_diff'
                          onClick={() => {
                            setSamesiesAddress(false);
                          }}
                          sx={{
                            marginTop: 3
                          }}
                        />
                      </Grid>}
                      {!samesiesAddress && <>
                        <Grid item xs={8}>
                          <TextInput
                            value={guardian?.street || ''}
                            onChange={(v) => {
                              setGuardian({
                                ...(guardian || {
                                  auth_token: '',
                                  email: ''
                                }),
                                street: v
                              });
                            }}
                            starred
                            caption={t("nw.user_info.street")}
                            sx={{
                              borderRadius: "8px",
                              width: '100%',
                              border: "2px solid transparent",
                              borderColor: theme.palette.primary.dark,
                              paddingTop: 0.25,
                              paddingBottom: 0.25,
                              height: '40px',
                              backgroundColor: 'transparent',
                            }}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextInput
                            value={guardian?.number || ''}
                            onChange={(v) => {
                              setGuardian({
                                ...(guardian || {
                                  auth_token: '',
                                  email: ''
                                }),
                                number: v
                              });
                            }}
                            starred
                            caption={t("nw.user_info.number")}
                            sx={{
                              borderRadius: "8px",
                              width: '100%',
                              border: "2px solid transparent",
                              borderColor: theme.palette.primary.dark,
                              paddingTop: 0.25,
                              paddingBottom: 0.25,
                              height: '40px',
                              backgroundColor: 'transparent',
                            }}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextInput
                            value={guardian?.zip || ''}
                            onChange={(v) => {
                              setGuardian({
                                ...(guardian || {
                                  auth_token: '',
                                  email: ''
                                }),
                                zip: v
                              });
                            }}
                            starred
                            caption={t("nw.user_info.zip")}
                            sx={{
                              borderRadius: "8px",
                              width: '100%',
                              border: "2px solid transparent",
                              borderColor: theme.palette.primary.dark,
                              paddingTop: 0.25,
                              paddingBottom: 0.25,
                              height: '40px',
                              backgroundColor: 'transparent',
                            }}
                          />
                        </Grid>
                        <Grid item xs={8}>
                          <TextInput
                            value={guardian?.city || ''}
                            onChange={(v) => {
                              setGuardian({
                                ...(guardian || {
                                  auth_token: '',
                                  email: ''
                                }),
                                city: v
                              });
                            }}
                            starred
                            caption={t("nw.user_info.city")}
                            sx={{
                              borderRadius: "8px",
                              width: '100%',
                              border: "2px solid transparent",
                              borderColor: theme.palette.primary.dark,
                              paddingTop: 0.25,
                              paddingBottom: 0.25,
                              height: '40px',
                              backgroundColor: 'transparent',
                            }}
                          />
                        </Grid>
                      </>}
                    </Grid>
                  </>}
                  {!(!!newUser?.birth_date && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y").isValid && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18})) && <>
                    <Grid item xs={12} sx={{textAlign: 'left'}}>
                      <Typography variant="h4" sx={{
                        marginTop: 4,
                        display: 'inline-block'
                      }}>{t("nw.emission.choice_me_new_itsme.title_contact_extra")}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <TextInput
                        value={newUser?.email || ''}
                        onChange={(v) => {
                          setNewUser({
                            ...(newUser || {
                              auth_token: '',
                              email: ''
                            }),
                            email: v
                          });
                        }}
                        starred
                        caption={t("nw.user_info.email")}
                        sx={{
                          borderRadius: "8px",
                          width: '100%',
                          border: "2px solid transparent",
                          borderColor: theme.palette.primary.dark,
                          paddingTop: 0.25,
                          paddingBottom: 0.25,
                          height: '40px',
                          backgroundColor: 'transparent',
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextInput
                        value={newUser?.phone || ''}
                        onChange={(v) => {
                          setNewUser({
                            ...(newUser || {
                              auth_token: '',
                              email: ''
                            }),
                            phone: v.toString()
                          });
                        }}
                        starred
                        caption={t("nw.user_info.phone")}
                        sx={{
                          borderRadius: "8px",
                          width: '100%',
                          border: "2px solid transparent",
                          borderColor: theme.palette.primary.dark,
                          paddingTop: 0.25,
                          paddingBottom: 0.25,
                          height: '40px',
                          backgroundColor: 'transparent',
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{textAlign: 'left'}}>
                      <Typography variant="h4" sx={{
                        marginTop: 4,
                        display: 'inline-block'
                      }}>{t("nw.emission.choice_me_new_itsme.title_address")}</Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <TextInput
                        value={newUser?.street || ''}
                        onChange={(v) => {
                          setNewUser({
                            ...(newUser || {
                              auth_token: '',
                              email: ''
                            }),
                            street: v
                          });
                        }}
                        starred
                        caption={t("nw.user_info.street")}
                        sx={{
                          borderRadius: "8px",
                          width: '100%',
                          border: "2px solid transparent",
                          borderColor: theme.palette.primary.dark,
                          paddingTop: 0.25,
                          paddingBottom: 0.25,
                          height: '40px',
                          backgroundColor: 'transparent',
                        }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextInput
                        value={newUser?.number || ''}
                        onChange={(v) => {
                          setNewUser({
                            ...(newUser || {
                              auth_token: '',
                              email: ''
                            }),
                            number: v
                          });
                        }}
                        starred
                        caption={t("nw.user_info.number")}
                        sx={{
                          borderRadius: "8px",
                          width: '100%',
                          border: "2px solid transparent",
                          borderColor: theme.palette.primary.dark,
                          paddingTop: 0.25,
                          paddingBottom: 0.25,
                          height: '40px',
                          backgroundColor: 'transparent',
                        }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextInput
                        value={newUser?.zip || ''}
                        onChange={(v) => {
                          setNewUser({
                            ...(newUser || {
                              auth_token: '',
                              email: ''
                            }),
                            zip: v
                          });
                        }}
                        starred
                        caption={t("nw.user_info.zip")}
                        sx={{
                          borderRadius: "8px",
                          width: '100%',
                          border: "2px solid transparent",
                          borderColor: theme.palette.primary.dark,
                          paddingTop: 0.25,
                          paddingBottom: 0.25,
                          height: '40px',
                          backgroundColor: 'transparent',
                        }}
                      />
                    </Grid>
                    <Grid item xs={8}>
                      <TextInput
                        value={newUser?.city || ''}
                        onChange={(v) => {
                          setNewUser({
                            ...(newUser || {
                              auth_token: '',
                              email: ''
                            }),
                            city: v
                          });
                        }}
                        starred
                        caption={t("nw.user_info.city")}
                        sx={{
                          borderRadius: "8px",
                          width: '100%',
                          border: "2px solid transparent",
                          borderColor: theme.palette.primary.dark,
                          paddingTop: 0.25,
                          paddingBottom: 0.25,
                          height: '40px',
                          backgroundColor: 'transparent',
                        }}
                      />
                    </Grid>
                  </>}
                  <Grid item xs={12} sx={{textAlign: 'left'}}>
                    <Typography variant="h4" sx={{
                      marginTop: 4,
                      display: 'inline-block'
                    }}>{t("nw.emission.choice_me_new_itsme.title_banking")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <ZichtAccount
                      value={newUser?.zicht_account || ''}
                      onChange={(v) => {
                        setNewUser({
                          ...(newUser || {
                            auth_token: '',
                            email: ''
                          }),
                          zicht_account: v.target.value
                        });
                      }}
                      setExternalIsOkay={setIsOkay}
                      starred
                      caption={t("nw.user_info.zicht_account")}
                      sx={{
                        borderRadius: "8px",
                        width: '100%',
                        border: "2px solid transparent",
                        borderColor: theme.palette.primary.dark,
                        paddingTop: 0.25,
                        paddingBottom: 0.25,
                        height: '40px',
                        backgroundColor: 'transparent',
                      }}
                    />
                  </Grid>
                  {/* <Grid item xs={12} sx={{textAlign: 'center'}}>
                    <Typography variant="h4" sx={{
                      marginTop: 4,
                      display: 'inline-block'
                    }}>{t("nw.emission.choice_me_new_itsme.title_identity")}</Typography>
                  </Grid> */}
                  {/* {!(!!newUser?.birth_date && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y").isValid && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18})) && <>
                    <Grid item xs={12} sx={{
                      display: {
                        xs: 'none', md: 'flex'
                      },
                      "& .cust_dropzonearea > div > div": {
                        flexBasis: 'auto !important',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      }
                    }}>
                      <DropzoneArea
                        acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                        filesLimit={1}
                        fileObjects={[]}
                        dropzoneText={he.decode(t('nw.general.dropzone_text').replace(/<[^>]*>?/gm, ''))}
                        onChange={(files) => {
                          // this.setState({user: {...this.state.user, identity: files[0]}});
                          setNewUser({
                            ...(newUser || {
                              auth_token: '',
                              email: ''
                            }),
                            identity: files[0]
                          });
                        }}
                        maxFileSize={5000000}
                        previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                        dropzoneClass="cust_dropzonearea"
                      />
                    </Grid>
                    <Grid item xs={12} sx={{
                      display: {
                        xs: 'flex', md: 'none'
                      },
                      "& .cust_dropzonearea > div > div": {
                        flexBasis: 'auto !important',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      }
                    }}>
                      <DropzoneArea
                        acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                        filesLimit={1}
                        fileObjects={[]}
                        dropzoneText={he.decode(t('nw.general.dropzone_text_mobile').replace(/<[^>]*>?/gm, ''))}
                        onChange={(files) => {
                          // this.setState({user: {...this.state.user, identity: files[0]}});
                          setNewUser({
                            ...(newUser || {
                              auth_token: '',
                              email: ''
                            }),
                            identity: files[0]
                          });
                        }}
                        maxFileSize={5000000}
                        previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                        dropzoneClass="cust_dropzonearea"
                      />
                    </Grid>
                  </>}
                  {!!newUser?.birth_date && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y").isValid && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18}) && <>
                    <Grid item xs={12} md={6} container spacing={2} sx={{alignContent: 'baseline'}}>
                      <Grid item xs={12} sx={{textAlign: 'center'}}>
                        <Typography variant="subtitle1" html fuck_p_tags sx={{
                          display: 'inline-block',
                        }}>{t("nw.emission.choice_minor.title_identity_ven")}</Typography>
                      </Grid>
                      <Grid item xs={12} sx={{
                        display: {
                          xs: 'none', md: 'flex'
                        },
                        "& .cust_dropzonearea > div > div": {
                          flexBasis: 'auto !important',
                          marginLeft: 'auto',
                          marginRight: 'auto'
                        }
                      }}>
                        <DropzoneArea
                          acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                          filesLimit={1}
                          fileObjects={[]}
                          dropzoneText={he.decode(t('nw.general.dropzone_text').replace(/<[^>]*>?/gm, ''))}
                          onChange={(files) => {
                            // this.setState({user: {...this.state.user, identity: files[0]}});
                            setNewUser({
                              ...(newUser || {
                                auth_token: '',
                                email: ''
                              }),
                              identity: files[0]
                            });
                          }}
                          maxFileSize={5000000}
                          previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                          dropzoneClass="cust_dropzonearea"
                        />
                      </Grid>
                      <Grid item xs={12} sx={{
                        display: {
                          xs: 'flex', md: 'none'
                        },
                        "& .cust_dropzonearea > div > div": {
                          flexBasis: 'auto !important',
                          marginLeft: 'auto',
                          marginRight: 'auto'
                        }
                      }}>
                        <DropzoneArea
                          acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                          filesLimit={1}
                          fileObjects={[]}
                          dropzoneText={he.decode(t('nw.general.dropzone_text_mobile').replace(/<[^>]*>?/gm, ''))}
                          onChange={(files) => {
                            // this.setState({user: {...this.state.user, identity: files[0]}});
                            setNewUser({
                              ...(newUser || {
                                auth_token: '',
                                email: ''
                              }),
                              identity: files[0]
                            });
                          }}
                          maxFileSize={5000000}
                          previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                          dropzoneClass="cust_dropzonearea"
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={6} container spacing={2} sx={{alignContent: 'baseline'}}>
                      <Grid item xs={12} sx={{textAlign: 'center'}}>
                        <Typography variant="subtitle1" html fuck_p_tags sx={{
                          display: 'inline-block',
                        }}>{t("nw.emission.choice_minor.title_identity_guardian")}</Typography>
                      </Grid>
                      <Grid item xs={12} sx={{
                        display: {
                          xs: 'none', md: 'flex'
                        },
                        "& .cust_dropzonearea > div > div": {
                          flexBasis: 'auto !important',
                          marginLeft: 'auto',
                          marginRight: 'auto'
                        }
                      }}>
                        <DropzoneArea
                          acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                          filesLimit={1}
                          fileObjects={[]}
                          dropzoneText={he.decode(t('nw.general.dropzone_text').replace(/<[^>]*>?/gm, ''))}
                          onChange={(files) => {
                            // this.setState({user: {...this.state.user, identity: files[0]}});
                            setGuardian({
                              ...(guardian || {
                                auth_token: '',
                                email: ''
                              }),
                              identity: files[0]
                            });
                          }}
                          maxFileSize={5000000}
                          previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                          dropzoneClass="cust_dropzonearea"
                        />
                      </Grid>
                      <Grid item xs={12} sx={{
                        display: {
                          xs: 'flex', md: 'none'
                        },
                        "& .cust_dropzonearea > div > div": {
                          flexBasis: 'auto !important',
                          marginLeft: 'auto',
                          marginRight: 'auto'
                        }
                      }}>
                        <DropzoneArea
                          acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                          filesLimit={1}
                          fileObjects={[]}
                          dropzoneText={he.decode(t('nw.general.dropzone_text_mobile').replace(/<[^>]*>?/gm, ''))}
                          onChange={(files) => {
                            // this.setState({user: {...this.state.user, identity: files[0]}});
                            setGuardian({
                              ...(guardian || {
                                auth_token: '',
                                email: ''
                              }),
                              identity: files[0]
                            });
                          }}
                          maxFileSize={5000000}
                          previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                          dropzoneClass="cust_dropzonearea"
                        />
                      </Grid>
                    </Grid>
                  </>} */}
                  <Grid item xs={12} sx={{textAlign: 'center'}}>
                    <Typography variant="h4" sx={{
                      marginTop: 4,
                      display: 'inline-block'
                    }}>{t("nw.emission.choice_me_new_itsme.title_overview")}</Typography>
                  </Grid>
                  <Grid item xs={12} sx={{textAlign: 'left'}}>
                    {!(!newUser?.first_name || !newUser.last_name || !newUser.birth_date || !newUser.gender || !DateTime.fromFormat(newUser?.birth_date, "dd/LL/y").isValid) && <CheckCircleOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.primary.light}} />}
                    {!!(!newUser?.first_name || !newUser.last_name || !newUser.birth_date || !newUser.gender || !DateTime.fromFormat(newUser?.birth_date, "dd/LL/y").isValid) && <ErrorOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.warning.main}} />}
                    <Typography variant="subtitle1" sx={{
                      marginTop: 1,
                      display: 'inline-block',
                      color: (!newUser?.first_name || !newUser.last_name || !newUser.birth_date || !newUser.gender || !DateTime.fromFormat(newUser?.birth_date, "dd/LL/y").isValid) ? theme.palette.warning.main : theme.palette.primary.light,
                      // maxWidth: {
                      //   xs: '100%',
                      //   lg: '440px'
                      // }
                    }}>{t("nw.emission.choice_me_new_itsme.title_personal")}</Typography>
                  </Grid>
                  {!!newUser?.birth_date && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y").isValid && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18}) && <Grid item xs={12} sx={{textAlign: 'left'}}>
                    {!(!guardian?.first_name || !guardian.last_name || !guardian.birth_date || !DateTime.fromFormat(guardian?.birth_date, "dd/LL/y").isValid || DateTime.fromFormat(guardian?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18})) && <CheckCircleOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.primary.light}} />}
                    {!!(!guardian?.first_name || !guardian.last_name || !guardian.birth_date || !DateTime.fromFormat(guardian?.birth_date, "dd/LL/y").isValid || DateTime.fromFormat(guardian?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18})) && <ErrorOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.warning.main}} />}
                    <Typography variant="subtitle1" sx={{
                      marginTop: 1,
                      display: 'inline-block',
                      color: (!guardian?.first_name || !guardian.last_name || !guardian.birth_date || !DateTime.fromFormat(guardian?.birth_date, "dd/LL/y").isValid || DateTime.fromFormat(guardian?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18})) ? theme.palette.warning.main : theme.palette.primary.light,
                      // maxWidth: {
                      //   xs: '100%',
                      //   lg: '440px'
                      // }
                    }}>{t("nw.emission.choice_me_new_itsme.title_personal_guardian")}</Typography>
                  </Grid>}
                  {!(!!newUser?.birth_date && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y").isValid && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18})) && <>
                    <Grid item xs={12} sx={{textAlign: 'left'}}>
                      {!(!newUser?.phone || !newUser?.email || !emailCheck(newUser?.email || '')) && <CheckCircleOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.primary.light}} />}
                      {!!(!newUser?.phone || !newUser?.email || !emailCheck(newUser?.email || '')) && <ErrorOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.warning.main}} />}
                      <Typography variant="subtitle1" sx={{
                        marginTop: 1,
                        display: 'inline-block',
                        color: (!newUser?.phone || !newUser?.email || !emailCheck(newUser?.email || '')) ? theme.palette.warning.main : theme.palette.primary.light,
                        // maxWidth: {
                        //   xs: '100%',
                        //   lg: '440px'
                        // }
                      }}>{t("nw.emission.choice_me_new_itsme.title_contact_extra")}</Typography>
                    </Grid>
                    <Grid item xs={12} sx={{textAlign: 'left'}}>
                      {!(!newUser?.street || !newUser.number || !newUser.zip || !newUser.city) && <CheckCircleOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.primary.light}} />}
                      {!!(!newUser?.street || !newUser.number || !newUser.zip || !newUser.city) && <ErrorOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.warning.main}} />}
                      <Typography variant="subtitle1" sx={{
                        marginTop: 1,
                        display: 'inline-block',
                        color: (!newUser?.street || !newUser.number || !newUser.zip || !newUser.city) ? theme.palette.warning.main : theme.palette.primary.light,
                        // maxWidth: {
                        //   xs: '100%',
                        //   lg: '440px'
                        // }
                      }}>{t("nw.emission.choice_me_new_itsme.title_address")}</Typography>
                    </Grid>
                  </>}
                  {!!newUser?.birth_date && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y").isValid && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18}) && <>
                    <Grid item xs={12} sx={{textAlign: 'left'}}>
                      {!(!newUser?.phone || !newUser?.email || !emailCheck(newUser?.email || '') || (!samesiesContact && (!guardian?.email || !emailCheck(guardian?.email || '') || !guardian.phone))) && <CheckCircleOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.primary.light}} />}
                      {!!(!newUser?.phone || !newUser?.email || !emailCheck(newUser?.email || '') || (!samesiesContact && (!guardian?.email || !emailCheck(guardian?.email || '') || !guardian.phone))) && <ErrorOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.warning.main}} />}
                      <Typography variant="subtitle1" sx={{
                        marginTop: 1,
                        display: 'inline-block',
                        color: (!newUser?.phone || !newUser?.email || (!samesiesContact && (!guardian?.email || !emailCheck(guardian?.email || '') || !guardian.phone))) ? theme.palette.warning.main : theme.palette.primary.light,
                        // maxWidth: {
                        //   xs: '100%',
                        //   lg: '440px'
                        // }
                      }}>{t("nw.emission.choice_me_new_itsme.title_contact_extra")}</Typography>
                    </Grid>
                    <Grid item xs={12} sx={{textAlign: 'left'}}>
                      {!(!newUser?.street || !newUser.number || !newUser.zip || !newUser.city || (!samesiesAddress && (!guardian?.street || !guardian.number || !guardian.zip || !guardian.city))) && <CheckCircleOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.primary.light}} />}
                      {!!(!newUser?.street || !newUser.number || !newUser.zip || !newUser.city || (!samesiesAddress && (!guardian?.street || !guardian.number || !guardian.zip || !guardian.city))) && <ErrorOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.warning.main}} />}
                      <Typography variant="subtitle1" sx={{
                        marginTop: 1,
                        display: 'inline-block',
                        color: (!newUser?.street || !newUser.number || !newUser.zip || !newUser.city || (!samesiesAddress && (!guardian?.street || !guardian.number || !guardian.zip || !guardian.city))) ? theme.palette.warning.main : theme.palette.primary.light,
                        // maxWidth: {
                        //   xs: '100%',
                        //   lg: '440px'
                        // }
                      }}>{t("nw.emission.choice_me_new_itsme.title_address")}</Typography>
                    </Grid>
                  </>}
                  <Grid item xs={12} sx={{textAlign: 'left'}}>
                    {!(!newUser?.zicht_account || !isOkay) && <CheckCircleOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.primary.light}} />}
                    {!!(!newUser?.zicht_account || !isOkay) && <ErrorOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.warning.main}} />}
                    <Typography variant="subtitle1" sx={{
                      marginTop: 1,
                      display: 'inline-block',
                      color: (!newUser?.zicht_account || !isOkay) ? theme.palette.warning.main : theme.palette.primary.light,
                      // maxWidth: {
                      //   xs: '100%',
                      //   lg: '440px'
                      // }
                    }}>{t("nw.emission.choice_me_new_itsme.title_banking")}</Typography>
                  </Grid>
                  {/* {!(!!newUser?.birth_date && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y").isValid && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18})) && <>
                    <Grid item xs={12} sx={{textAlign: 'left'}}>
                      {!(!newUser?.identity) && <CheckCircleOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.primary.light}} />}
                      {!!(!newUser?.identity) && <ErrorOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.warning.main}} />}
                      <Typography variant="subtitle1" sx={{
                        marginTop: 1,
                        display: 'inline-block',
                        color: (!newUser?.identity) ? theme.palette.warning.main : theme.palette.primary.light,
                        // maxWidth: {
                        //   xs: '100%',
                        //   lg: '440px'
                        // }
                      }}>{t("nw.emission.choice_me_new_itsme.title_identity")}</Typography>
                    </Grid>
                  </>} */}
                  {/* {!!newUser?.birth_date && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y").isValid && DateTime.fromFormat(newUser?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18}) && <>
                    <Grid item xs={12} sx={{textAlign: 'left'}}>
                      {!(!newUser?.identity || !guardian?.identity) && <CheckCircleOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.primary.light}} />}
                      {!!(!newUser?.identity || !guardian?.identity) && <ErrorOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.warning.main}} />}
                      <Typography variant="subtitle1" sx={{
                        marginTop: 1,
                        display: 'inline-block',
                        color: (!newUser?.identity || !guardian?.identity) ? theme.palette.warning.main : theme.palette.primary.light,
                        // maxWidth: {
                        //   xs: '100%',
                        //   lg: '440px'
                        // }
                      }}>{t("nw.emission.choice_me_new_itsme.title_identity")}</Typography>
                    </Grid>
                  </>} */}
                </Grid>
              </>}

              {/* Choose amount */}
              <Grid item xs={12} sx={{
                marginTop: 4
              }}>
                <Typography variant="h4" html>{t("nw.transfers.new_transfer.amount_info")}</Typography>
              </Grid>
              {maxGiftable > -1 && <>
                <Grid item xs={12} sx={{
                  marginBottom: 2.5
                }}>
                  <Typography variant="subtitle1" html>{t("nw.transfers.new_transfer.amount_maximum", {amount: maxGiftable})}</Typography>
                </Grid>
                <Grid item xs={6} sx={{
                  marginBottom: 2.5
                }}>
                  <TextInput
                    value={activeKey.proposed_amount?.toString() || ''}
                    id='amount'
                    onChange={(v) => {
                      let a = parseInt(v, 10);
                      if (!a || a < 0 || a > (maxGiftable || 0)) a = 0;
                      setActiveKey({
                        ...activeKey,
                        proposed_amount: a
                      });
                    }}
                    sx={{
                      borderRadius: "8px",
                      width: '100%',
                      border: "2px solid transparent",
                      borderColor: theme.palette.primary.dark,
                      paddingTop: 0.25,
                      paddingBottom: 0.25,
                      height: '40px',
                      backgroundColor: 'transparent',
                      marginTop: -1
                    }}
                  />
                </Grid>
                <Grid item xs={6} sx={{alignSelf: 'center',
                  marginBottom: 2.5,
                  paddingLeft: 2.5
                }}>
                  <Typography variant="body1">{t("nw.emission.steps.stock.field.amount_calculated", {
                    amount: ((activeKey.proposed_amount || 0) * 50).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  })}</Typography>
                </Grid>
              </>}
              {false && maxGiftable < 1 && <Grid item xs={12} sx={{
                marginTop: 1
              }}>
                <ErrorBox
                  type="error"
                  text={t("nw.transfers.new_transfer.amount_error")}
                />
              </Grid>}

              {/* confirm */}

              <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4, paddingRight: {xs: 0, md: 2.5}}}>
                <TextButton
                  id="back_btn"
                  label={t("nw.emission.forgot.cta_back")}
                  onClick={() => {
                    setActiveKey(undefined);
                    setNewUser({
                      auth_token: '',
                      email: '',
                      gender: 'M'
                    });
                    setGuardian({
                      email: ''
                    });
                    window.scrollTo(0, 0);
                  }}
                  sx={{
                    marginLeft: 1,
                    marginRight: 1,
                    marginTop: 1
                  }}
                />
                <DarkGreenButton
                  id="next_btn"
                  loading={!!mutationCustomAction.isPending || transfersLoading}
                  label={t("nw.emission.choice_me_new_itsme.cta_next")}
                  disabled={
                    !!mutationCustomAction.isPending || transfersLoading || pickReceiverState === 1 ? (!receiverInfo.id || (activeKey.proposed_amount || 0) < 1 || (activeKey.proposed_amount || 0) > maxGiftable) : 
                    !newUser?.birth_date || DateTime.fromFormat(newUser?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18}) ? (
                      !newUser?.first_name || !newUser.last_name || !newUser.phone || !newUser.zicht_account || 
                      !newUser.street || !newUser.number || !newUser.zip || !newUser.city || !newUser.birth_date || 
                      !guardian?.first_name || !guardian.last_name || 
                      // !newUser.identity || !guardian?.identity || !guardian.first_name || !guardian.last_name || 
                      !newUser.phone || !newUser?.email || !emailCheck(newUser?.email || '') || (!samesiesContact && (
                        !guardian?.email || !guardian.phone || !emailCheck(guardian?.email || '')
                      )) || (!samesiesAddress && (
                        !guardian?.street || !guardian.number || !guardian.zip || !guardian.city
                      )) || !DateTime.fromFormat(newUser?.birth_date, "dd/LL/y").isValid || 
                      !DateTime.fromFormat(guardian?.birth_date, "dd/LL/y").isValid || 
                      DateTime.fromFormat(guardian?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18}) || 
                      (activeKey.proposed_amount || 0) < 1 || (activeKey.proposed_amount || 0) > maxGiftable
                    ) : (
                      !newUser?.first_name || !newUser.last_name || !newUser.email || !emailCheck(newUser?.email || '') || 
                      !newUser.phone || !newUser.zicht_account || 
                      !newUser.street || !newUser.number || !newUser.zip || !newUser.city || !newUser.birth_date || 
                      !DateTime.fromFormat(newUser?.birth_date, "dd/LL/y").isValid || 
                      // !newUser.identity || !DateTime.fromFormat(newUser?.birth_date, "dd/LL/y").isValid || 
                      DateTime.fromFormat(newUser?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18}) || 
                      (activeKey.proposed_amount || 0) < 1 || (activeKey.proposed_amount || 0) > maxGiftable
                    )
                  }
                  onClick={() => {
                    if (!mutationCustomAction.isPending) {
                      // onSubmit();
                      setOpenId(undefined);
                      const ob:any = {
                        object: 'stock_transfer',
                        class_action: 'custom_api_create_transfer',
                        // identity_self: item,
                        amount: activeKey.proposed_amount
                      };
                      if (!!activeKey.id) ob.st_id = activeKey.id;
                      if (pickReceiverState === 1) {
                        ob.existing_id = receiverInfo.id;
                      }
                      if (pickReceiverState === 2) {
                        // ob.identity = newUser?.identity;
                        // ob.identity_guardian = guardian?.identity;
                        ob.new_user = {
                          ...newUser,
                          zicht_account: newUser.zicht_account?.replace(/\s/g, '')
                        };
                        ob.guardian = guardian;
                      }

                      // const formData = new FormData();
                      // Object.keys(ob).forEach(key => {
                      //   if (key === 'new_user' || key === 'guardian') {
                      //     if (!!ob[key]) {
                      //       Object.entries(ob[key]).forEach(entry => {
                      //         const [kkey, kvalue] = entry;
                      //         // @ts-ignore
                      //         formData.append(`${key}[${kkey}]`, kvalue.toString());
                      //       });
                      //     }
                      //   } else {
                      //     // @ts-ignore
                      //     if (!!ob[key]) formData.append(key, ob[key]);
                      //   }
                      // });

                      mutationCustomAction.mutate({
                        formData: ob
                      })
                    }
                  }}
                  sx={{
                    marginLeft: 1,
                    marginRight: 1,
                    marginTop: 1,
                    color: 'white !important'
                  }}
                />
              </Grid>
            </>}
          </>}

          {/* {activeKey.status_key === 'open' && <>
            <Grid item xs={12} sx={{
              marginBottom: 2.5
            }}>
              {login?.share_type_tag !== 'A' && <Typography variant="body1" html sx={{
                marginTop: -1
              }}>{t("nw.emission.steps.stock.order_extra")}</Typography>}
              {login?.share_type_tag === 'A' && <Typography variant="body1" html sx={{
                marginTop: -1
              }}>{t("nw.emission.steps.stock_for_a.order_extra")}</Typography>}
            </Grid>
            <Grid item xs={12} sx={{marginTop: -1, marginBottom: 2.5}}>
              <Typography variant="caption">{t(`nw.emission.steps.stock.field.amount`)}</Typography>
            </Grid>
            <Grid item xs={6} sx={{
              marginBottom: 2.5
            }}>
              <TextInput
                value={activeKey.proposed_amount?.toString() || ''}
                id='amount'
                onChange={(v) => {
                  let a = parseInt(v, 10);
                  if (!a || a < 0 || a > (login?.available_stock_number || 0)) a = 0;
                  setActiveKey({
                    ...activeKey,
                    proposed_amount: a
                  });
                }}
                sx={{
                  borderRadius: "8px",
                  width: '100%',
                  border: "2px solid transparent",
                  borderColor: theme.palette.primary.dark,
                  paddingTop: 0.25,
                  paddingBottom: 0.25,
                  height: '40px',
                  backgroundColor: 'transparent',
                  marginTop: -1
                }}
              />
            </Grid>
            <Grid item xs={6} sx={{alignSelf: 'center',
              marginBottom: 2.5,
              paddingLeft: 2.5
            }}>
              <Typography variant="body1">{t("nw.emission.steps.stock.field.amount_calculated", {
                amount: ((activeKey.proposed_amount || 0) * (login?.share_type_tag === "A" ? 100 : 50)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
              })}</Typography>
            </Grid>
            <Grid item xs={12} sx={{
              marginBottom: 2.5
            }}>
              <Typography variant="body1" sx={{
                fontStyle: 'italic',
                fontSize: '0.8rem',
                marginTop: -1
              }}>{t("nw.emission.steps.stock.max_amount_note", {amount: (login?.available_stock_number?.toString() || '200')})}</Typography>
            </Grid>
          </>} */}





          {/* <Grid item xs={12} sx={{textAlign: 'right', marginBottom: 8}}>
            <Box sx={{
              display: 'block',
              width: '100%',
              maxWidth: {
                xs: '100%',
                lg: '440px'
              },
              marginTop: 2,
              marginRight: 'auto',
              marginLeft: 'auto',
              textAlign: 'right'
            }}>
              <Box sx={{
                display: 'inline-block',
                width: '100%',
                textAlign: 'center',
              }}>
                <TextButton
                  label={t("nw.emission.forgot.cta_back")}
                  id="sub_btn"
                  onClick={() => {
                    setActiveKey(undefined);
                  }}
                  sx={{
                    marginBottom: 1,
                    color: theme.palette.primary.dark,
                    textDecoration: 'underline',
                    "&:hover": {
                      color: theme.palette.primary.light,
                      backgroundColor: 'transparent'
                    },
                    paddingLeft: 0,
                    paddingRight: 0
                  }}
                />
              </Box>
            </Box>
          </Grid> */}
        </>}
      </Grid>
    </WhiteSection>
  </Page>;
}

